import { render, staticRenderFns } from "./dialog-set-password.vue?vue&type=template&id=9a636b0c&scoped=true&"
import script from "./dialog-set-password.vue?vue&type=script&lang=js&"
export * from "./dialog-set-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a636b0c",
  null
  
)

export default component.exports